import { MailFile, MailFileThumbnailType } from '@ukpostbox/client-data/lib/Types/MailFileTypes';
import React from 'react';
import { ThumbnailSize } from '@ukpostbox/frontend-framework/lib/Components/Images/Thumbnails/ThumbnailTypes';

export enum MailPartTypeEnum {
	'Mail-Envelopes' = 1,
	'Mail-Contents' = 2,
}

export enum ContentsTypeEnum {
	'Mail-Envelopes',
	'Mail-Contents',
	'Mail-Sends',
}

export type MailItemThumbnailsType = {
	files: Array<MailFile>;
	onClickCallback?: (e: React.MouseEvent | React.KeyboardEvent, link?: string) => void;
	size?: ThumbnailSize;
};

export interface MapMailItemThumbnailsType {
	files: Array<MailFile>;
	mailType: MailPartTypeEnum;
	onClickCallback?: (e: React.MouseEvent | React.KeyboardEvent, link: string) => void;
	hideMissing?: boolean;
	size?: ThumbnailSize;
}

export interface MapSingleMailItemThumbnailType extends Omit<MapMailItemThumbnailsType, 'files'> {
	file: MailFile;
}

export interface MailFileThumbnailCustomType extends MailFileThumbnailType {
	size?: ThumbnailSize;
	tooltipPreview?: string;
	onClickCallback?: (e: React.MouseEvent | React.KeyboardEvent, link: string) => void;
}

export type MailItemLockedThumbnailType = {
	size?: ThumbnailSize;
};

export type MailItemNoThumbnailType = {
	mailType: MailPartTypeEnum;
	size?: ThumbnailSize;
};

export type MailItemTopUpRequiredThumbnailType = {
	size?: ThumbnailSize;
};
